import { __awaiter } from "tslib";
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ReducerType } from '../types';
import { MISSING_CUSTOMER } from '@open-tender/types';
import { checkAuth, selectToken } from './account';
import { setSelectedAllergens } from '../allergens';
import { showNotification } from '../notifications';
const initialState = {
    entities: [],
    lookup: {},
    loading: 'idle',
    error: null
};
export var CustomerAllergensActionType;
(function (CustomerAllergensActionType) {
    CustomerAllergensActionType["FetchCustomerAllergens"] = "customer/fetchCustomerAllergens";
    CustomerAllergensActionType["UpdateCustomerAllergens"] = "customer/updateCustomerAllergens";
})(CustomerAllergensActionType || (CustomerAllergensActionType = {}));
export const fetchCustomerAllergens = createAsyncThunk(CustomerAllergensActionType.FetchCustomerAllergens, (_, { dispatch, getState, rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const api = getState().config.api;
        const token = selectToken(getState());
        if (!token)
            throw new Error(MISSING_CUSTOMER);
        const allergens = yield api.getCustomerAllergens(token);
        return allergens;
    }
    catch (err) {
        const error = err;
        return checkAuth(error, dispatch, () => rejectWithValue(error));
    }
}));
export const updateCustomerAllergens = createAsyncThunk(CustomerAllergensActionType.UpdateCustomerAllergens, (data, { dispatch, getState, rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const api = getState().config.api;
        const token = selectToken(getState());
        if (!token)
            throw new Error(MISSING_CUSTOMER);
        const allergens = yield api.putCustomerAllergens(token, data);
        dispatch(setSelectedAllergens(allergens || []));
        dispatch(showNotification('Allergens updated!'));
        return allergens;
    }
    catch (err) {
        const error = err;
        return checkAuth(error, dispatch, () => rejectWithValue(error));
    }
}));
const customerAllergensSlice = createSlice({
    name: ReducerType.CustomerAllergens,
    initialState,
    reducers: {
        resetCustomerAllergens: () => initialState,
        setCustomerAllergens: (state, action) => {
            state.entities = action.payload;
            state.error = null;
        }
    },
    extraReducers: builder => {
        builder
            .addCase(fetchCustomerAllergens.fulfilled, (state, action) => {
            state.entities = action.payload;
            state.loading = 'idle';
            state.error = null;
        })
            .addCase(fetchCustomerAllergens.pending, state => {
            state.loading = 'pending';
        })
            .addCase(fetchCustomerAllergens.rejected, (state, action) => {
            state.error = action.payload;
            state.loading = 'idle';
        })
            .addCase(updateCustomerAllergens.fulfilled, (state, action) => {
            state.entities = action.payload;
            state.loading = 'idle';
            state.error = null;
        })
            .addCase(updateCustomerAllergens.pending, state => {
            state.loading = 'pending';
        })
            .addCase(updateCustomerAllergens.rejected, (state, action) => {
            state.error = action.payload;
            state.loading = 'idle';
        });
    }
});
export const { resetCustomerAllergens, setCustomerAllergens } = customerAllergensSlice.actions;
export const selectCustomerAllergens = (state) => state.customer.allergens;
export const customerAllergensReducer = customerAllergensSlice.reducer;
